<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <p>Pending Cases</p>
            </div>
            <div class="row">
                        
                <div class="col-sm-6">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">    
                                <div class="col-md-3">
                                    <h5 class="card-title">Pending Cases</h5>
                                </div>                                               
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="pendingCases">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in TableHeaders">{{ item }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in PendingPageData">
                                            <td>{{ index }}</td>
                                            <td>{{ item.sex }}</td>
                                            <td>{{ item.nosex }}</td>
                                            <td>{{ item.nocat }}</td>
                                            <td>{{ item.sex + item.nosex + item.nocat }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    import 'datatables.net-bs4';
    import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
    import 'datatables.net-responsive-bs4';
    import 'datatables.net-buttons-bs4';
    import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
    import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js';
    import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
    import 'datatables.net-buttons/js/buttons.html5.js';

    export default {
        data() {
            return {
                TableHeaders: {},
                PendingPageData:{},
            }
        },
        mounted() {

        },
        updated: function () {
          this.$nextTick(function () {
                $('#pendingCases').DataTable({
                    responsive: true,
                    dom: 'Bfrtip',
                    lengthMenu: [
                         [-1, 50, 25, 10],
                         ['Show all', '50 rows',  '25 rows', '10 rows' ]
                     ],
                    "order": [
                        [0, "asc"]
                    ],
                    buttons: [
                        {extend:'pageLength'},
                        {extend: 'copyHtml5',
                            exportOptions: {
                                columns: [0, ':visible']
                            }
                        },      
                    ],
                });
          });
        },
        methods: {
            getTableData() {
                axios.get("/api/v1/pending-cases").then(({ data }) => {
                    this.TableHeaders = data.data.TableHeaders;
                    this.PendingPageData = data.data.PendingPageData;
                });
            }
        }, 
        created() {
            this.getTableData();
        }
    }
</script>
